var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, forkJoin } from 'rxjs';
import { BookedTrip, Flight, Passenger } from '@ibe/models';
import { Store } from '@ngrx/store';
import * as BookedTripActions from '@ibe/store/actions/booked-trip.actions';
import * as SeatmapActions from '@ibe/store/actions/seatmap.actions';
import { environment } from '../../../environments/environment';
import { catchError, tap } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/store";
import * as i2 from "@angular/common/http";
var TAPDataStorageService = /** @class */ (function () {
    function TAPDataStorageService(store, _http) {
        this.store = store;
        this._http = _http;
        this.seatMapData = new BehaviorSubject(null);
        this._bookedTrips = new Map();
        this._activeBookingMockLoaded = new BehaviorSubject(false);
        this._myBookingsMocksLoaded = new BehaviorSubject(false);
        this._retrievePNRLocatorMocksLoaded = new BehaviorSubject(false);
        this._activeBooking = new BookedTrip([], null, 'round trip');
        this._observableBookedTrips = new BehaviorSubject(this.bookedTrips);
        this._observableCurrentBooking = new BehaviorSubject(this.activeBooking);
    }
    TAPDataStorageService.prototype.initializeSeatmap = function (planeModel) {
        var _this = this;
        this.readSeatmapData(planeModel).subscribe(function (seatmap) {
            _this.store.dispatch(new SeatmapActions.PutSeatmapAction(seatmap));
        });
    };
    Object.defineProperty(TAPDataStorageService.prototype, "activeBookingMockLoaded", {
        get: function () {
            return this._activeBookingMockLoaded;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TAPDataStorageService.prototype, "retrievePNRLocatorMocksLoaded", {
        get: function () {
            return this._retrievePNRLocatorMocksLoaded;
        },
        enumerable: true,
        configurable: true
    });
    TAPDataStorageService.prototype.setRetrievePNRLocatorMocksLoaded = function (next) {
        this._retrievePNRLocatorMocksLoaded.next(next);
    };
    Object.defineProperty(TAPDataStorageService.prototype, "myBookingsMocksLoaded", {
        get: function () {
            return this._myBookingsMocksLoaded;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TAPDataStorageService.prototype, "seatmap", {
        get: function () {
            return this.seatMapData;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TAPDataStorageService.prototype, "bookedTrips", {
        get: function () {
            var trips = [];
            this._bookedTrips.forEach(function (val) { return trips.push(val); });
            return trips;
        },
        set: function (trips) {
            var _this = this;
            this._bookedTrips.clear();
            trips.forEach(function (trip) { return _this._bookedTrips.set(trip.pnr, trip); });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TAPDataStorageService.prototype, "activeBooking", {
        get: function () {
            return this._activeBooking;
        },
        set: function (booking) {
            this._activeBooking = booking;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TAPDataStorageService.prototype, "observableBookings", {
        get: function () {
            return this._observableBookedTrips;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TAPDataStorageService.prototype, "observableCurrentBooking", {
        get: function () {
            return this._observableCurrentBooking;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Initializes the data store with mock booked trips loaded from a file
     */
    TAPDataStorageService.prototype.initializeWithMockBookedTrips = function () {
        this.readTripsInitializerFile();
    };
    /**
     * Initializes the data store with a mock booking loaded from a file
     */
    TAPDataStorageService.prototype.initializeActiveMockBooking = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.readActiveBookingInitializerFile()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Initializes the data store with mocked booked trips if there's no
     * data present in it already
     */
    TAPDataStorageService.prototype.initializeBookingsIfEmpty = function () {
        if (this.bookedTrips.length === 0) {
            this.initializeWithMockBookedTrips();
        }
    };
    /**
     * Initializes the data store with a mocked booking if there's no
     * data present in it already
     */
    TAPDataStorageService.prototype.initializeActiveBookingIfEmpty = function () {
        if (this.activeBooking.flights.length === 0) {
            this.initializeActiveMockBooking();
        }
    };
    /**
     * Fills up mock costs for flight calendar/graph view
     */
    TAPDataStorageService.prototype.generateMockCosts = function () {
        var today = new Date(), oneYear = new Date(), result = [];
        oneYear.setDate(oneYear.getDate() + 365);
        var forceDaysWithPrice = 61; // first two months - dev only
        /** Generate true with a 80% probability on average */
        var truthGenerator = function () { return Math.random() > 0.2; };
        /** Generates a random number between min and the given max with two decimal places */
        var generateCost = function (min, max) {
            if (min === void 0) { min = 30; }
            if (max === void 0) { max = 967.52; }
            return Number.parseFloat((Math.random() * max).toFixed(2)) + min;
        };
        var generateAmount = function (dayWithFLights, currentDay) {
            if (dayWithFLights) {
                var val = generateCost();
                var dayWithPrice = (currentDay > forceDaysWithPrice) ? truthGenerator() : true;
                return {
                    currency: {
                        value: dayWithPrice ? val.toFixed(2) : null,
                        unit: dayWithPrice ? environment.currency.symbol : '',
                        name: dayWithPrice ? environment.currency.label : ''
                    },
                    points: dayWithPrice ? Math.round(val * 50 + 50) : null
                };
            }
            else {
                return null;
            }
        };
        var currentDay = 1;
        while (today <= oneYear) {
            var dayWithFLights = truthGenerator();
            result.push({
                date: new Date(today),
                ammount: generateAmount(dayWithFLights, currentDay),
                no_flights: !dayWithFLights ? this.getNoFlightsCause() : false
            });
            today.setDate(today.getDate() + 1);
            currentDay++;
        }
        return result;
    };
    TAPDataStorageService.prototype.getNoFlightsCause = function () {
        return Math.random() > 0.5 ? 'no flights' : 'sold out';
    };
    TAPDataStorageService.prototype.generateMockCostsPromise = function (delay) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var costs = _this.generateMockCosts();
            setTimeout(function () {
                resolve(costs);
            }, delay * 1000);
        });
    };
    /**
     * Resets the state of the current booking to an empty one
     */
    TAPDataStorageService.prototype.resetActiveBooking = function () {
        this.activeBooking = new BookedTrip([], null, 'round trip');
        this.activeBooking.addPassenger('adult');
        this.observableCurrentBooking.next(this.activeBooking);
        this._activeBookingMockLoaded.next(false);
    };
    /**
     * Retrieves a booked trip from the data store by its pnr identifier.
     * Returns the booked trip with that pnr if found, or undefined otherwise
     * @param {string} pnr - the booked trip identifier
     */
    TAPDataStorageService.prototype.getBookedTrip = function (pnr) {
        return this._bookedTrips.get(pnr);
    };
    /**
     * Stores the given booked trip in the storage
     * @param {BookedTrip} trip - the trip to store
     */
    TAPDataStorageService.prototype.addBookedTrip = function (trip) {
        this._bookedTrips.set(trip.pnr, trip);
        this._observableBookedTrips.next(this.bookedTrips);
    };
    /**
     * Update booking trip
     * @param {string} pnr of booking
     * @param {BookedTrip} updated_booked_trip Booked trip to update
     * @returns booking trip
     */
    TAPDataStorageService.prototype.updateBooking = function (pnr, updated_booked_trip) {
        this._bookedTrips.set(pnr, updated_booked_trip);
        this._observableBookedTrips.next(this.bookedTrips);
        this.store.dispatch(new BookedTripActions.PutBookedTripAction(updated_booked_trip));
    };
    /**
     * Reads JSON file and import mock data for active booking
     */
    TAPDataStorageService.prototype.readActiveBookingInitializerFile = function () {
        var _this = this;
        var url = './assets/data/active_booking.json';
        var filePromise = this._http.get(url).toPromise();
        return new Promise(function (resolve, reject) {
            filePromise.then(function (booking) {
                var originalPassengers = booking.passengers;
                booking.flights.forEach(function (flight) {
                    flight.departure.time = new Date(flight.departure.time);
                    flight.arrival.time = new Date(flight.arrival.time);
                    if (flight.check_in) {
                        flight.check_in.time = new Date(flight.check_in.time);
                    }
                    if (flight.stops) {
                        flight.stops = flight.stops.map(function (stop) {
                            stop.time = new Date(stop.time);
                            stop.departure = new Date(stop.departure);
                            return stop;
                        });
                    }
                });
                var neu_flight;
                var flights = booking.flights.map(function (flight) {
                    neu_flight = new Flight(flight.departure, flight.departure, flight.number);
                    Object.assign(neu_flight, flight);
                    return neu_flight;
                });
                var neu_booking = new BookedTrip(flights, booking.pnr, booking.booking_type, booking.status);
                if (originalPassengers.adults && originalPassengers.adults > 0) {
                    for (var i = 0; i < originalPassengers.adults; i++) {
                        neu_booking.addPassenger('adult');
                    }
                }
                if (originalPassengers.children && originalPassengers.children > 0) {
                    for (var i = 0; i < originalPassengers.children; i++) {
                        neu_booking.addPassenger('child');
                    }
                }
                if (originalPassengers.infants && originalPassengers.infants > 0) {
                    for (var i = 0; i < originalPassengers.infants; i++) {
                        neu_booking.addPassenger('infant');
                    }
                }
                _this.activeBooking = neu_booking;
                _this._activeBookingMockLoaded.next(true);
                resolve(neu_booking);
            }, function (err) {
                reject(err);
            });
        });
    };
    /**
     * Reads JSON files and import mock data for trips and passengers
     */
    TAPDataStorageService.prototype.readTripsInitializerFile = function () {
        var urlTripsFile = './assets/data/booked_trips.json';
        this.readInitializerFile(urlTripsFile);
    };
    /**
     * Reads JSON file and import mock data for retrieve PNR locator
     */
    TAPDataStorageService.prototype.initializerRetrievePNRLocator = function (tripPNR) {
        var urlTripsFile = './assets/data/booked_trips_find.json';
        this.readInitializerFile(urlTripsFile, tripPNR);
    };
    /**
     * Reads JSON file and import mock data for retrieve PNR locator
     */
    TAPDataStorageService.prototype.initializerRetrievePNRLocatorGroups = function (tripPNR) {
        var urlTripsFile = './assets/data/booked_trips_find-group.json';
        this.readInitializerFile(urlTripsFile, tripPNR);
    };
    /**
     * Reads JSON files and import mock data for trips and passengers
     */
    TAPDataStorageService.prototype.readInitializerFile = function (urlTripsFile, customPNR) {
        var _this = this;
        var urlTrips = urlTripsFile;
        var urlPassengers = './assets/data/passengers.json';
        var filePromiseTrips = this._http.get(urlTrips).toPromise();
        var filePromisePassengers = this._http
            .get(urlPassengers)
            .toPromise();
        forkJoin(filePromiseTrips, filePromisePassengers).subscribe(function (result) {
            var trips = result[0];
            var passengersExampleOri = result[1];
            var countTrip = 0;
            trips.forEach(function (trip) {
                var passengersExample = passengersExampleOri;
                trip.flights.forEach(function (flight) {
                    flight.departure.time = new Date(flight.departure.time);
                    flight.arrival.time = new Date(flight.arrival.time);
                    flight.check_in.time = new Date(flight.check_in.time);
                    if (flight.stops) {
                        flight.stops = flight.stops.map(function (stop) {
                            stop.time = new Date(stop.time);
                            stop.departure = new Date(stop.departure);
                            return stop;
                        });
                    }
                });
                var neu_flight;
                var flights = trip.flights.map(function (flight) {
                    neu_flight = new Flight(flight.departure, flight.departure, flight.number);
                    Object.assign(neu_flight, flight);
                    return neu_flight;
                });
                if (customPNR) {
                    trip.pnr = customPNR;
                    trip.added_to_account = false;
                }
                else {
                    trip.added_to_account = true;
                }
                var trip_passengers_info;
                if (trip.passengers_info === undefined) {
                    trip_passengers_info = [];
                }
                else {
                    trip_passengers_info = trip.passengers_info.map(function (cur) { return Object.assign(new Passenger(), cur); });
                    flights = flights.map(function (flight) { return Object.assign(new Flight(null, null, null), flight, { passengerInfo: [] }); });
                    flights.forEach(function (flight) { trip_passengers_info.forEach(function (passenger) { return flight.assignPassenger(passenger); }); });
                }
                var booking = new BookedTrip(flights, trip.pnr, trip.booking_type, trip.status, trip.passengers, trip_passengers_info, trip.payment, trip.contact_details, trip.is_time_to_think, trip.isCorporate, trip.time_to_think, trip.stopover, trip.travel_agency, trip.added_to_account, trip.loyalty_program, trip.is_group);
                var originalPassengers = trip.passengers;
                if (trip.passengers_info === undefined) {
                    /**
                     * To test
                     */
                    if (trip.pnr === 'TEST12') {
                        passengersExample = passengersExampleOri.filter(function (cur) { return ['Test', 'Test', 'Test'].includes(cur.firstName); });
                    }
                    var randomPassengerIDs_1 = [];
                    var randomPassenger = new Array(originalPassengers.adults +
                        originalPassengers.children +
                        originalPassengers.infants)
                        .fill(0)
                        .map(function (n) {
                        // Prevent repeated Exemple ID's
                        var newPassengerID = Math.floor(Math.random() * passengersExample.length - 1) + 1;
                        while (randomPassengerIDs_1.includes(newPassengerID)) {
                            newPassengerID =
                                Math.floor(Math.random() * passengersExample.length - 1) + 1;
                        }
                        randomPassengerIDs_1.push(newPassengerID);
                        return newPassengerID;
                    });
                    var passengerIndex = 0;
                    if (originalPassengers.adults && originalPassengers.adults > 0) {
                        for (var i = 0; i < originalPassengers.adults; i++) {
                            booking.addPassenger('adult');
                            booking.addPassengerDetails(passengersExample[randomPassenger[passengerIndex]], passengerIndex);
                            passengerIndex++;
                        }
                    }
                    if (originalPassengers.children &&
                        originalPassengers.children > 0) {
                        for (var i = 0; i < originalPassengers.children; i++) {
                            booking.addPassenger('child');
                            booking.addPassengerDetails(passengersExample[randomPassenger[passengerIndex]], passengerIndex);
                            passengerIndex++;
                        }
                    }
                    if (originalPassengers.infants && originalPassengers.infants > 0) {
                        for (var i = 0; i < originalPassengers.infants; i++) {
                            booking.addPassenger('infant');
                            booking.addPassengerDetails(passengersExample[randomPassenger[passengerIndex]], passengerIndex);
                            passengerIndex++;
                        }
                    }
                }
                _this.addBookedTrip(booking);
                ++countTrip;
                if (trips.length == countTrip)
                    _this._observableBookedTrips.complete();
            });
            if (customPNR) {
                _this._retrievePNRLocatorMocksLoaded.next(true);
            }
            else {
                _this._myBookingsMocksLoaded.next(true);
            }
        }, function (err) {
            console.error(err);
        });
    };
    /**
     * Reads JSON file and import mock data for seatmap
     */
    TAPDataStorageService.prototype.readSeatmapData = function (planeModel) {
        var _this = this;
        var url = false;
        // let url = './assets/data/seatmap-wide.json';
        if (planeModel) {
            url = "./assets/data/" + planeModel + ".json";
        }
        if (!url) {
            var observable = new BehaviorSubject(false);
            return observable;
        }
        else {
            return this._http.get(url)
                .pipe(tap(function (seatmap) { return seatmap; }), catchError(function (error) { return _this.handleError(error); }));
        }
    };
    /**
     * Add PNR's trip from "Find existing booking" to active bookings list
     * @param pnr PNR of trip to add to My Bookings
     */
    TAPDataStorageService.prototype.addBookingToAccount = function (pnr) {
        var tripToChange = this.getBookedTrip(pnr);
        tripToChange = Object.assign(new BookedTrip(null, null, null), tripToChange, { added_to_account: true });
        this.addBookedTrip(tripToChange);
    };
    TAPDataStorageService.prototype.handleError = function (error) {
        throw new Error('login error: ' + error.statusText);
    };
    TAPDataStorageService.ngInjectableDef = i0.defineInjectable({ factory: function TAPDataStorageService_Factory() { return new TAPDataStorageService(i0.inject(i1.Store), i0.inject(i2.HttpClient)); }, token: TAPDataStorageService, providedIn: "root" });
    return TAPDataStorageService;
}());
export { TAPDataStorageService };
